import React, {useEffect, useState} from 'react';
import ApiDataBase from 'server'
import UseContext from "hooks/useContext";

const LegalInformationContent = () => {
    const {companyData}=UseContext()
    const [selectConvention, setSelectConvention] = useState('')
    const [selectJuridique, setSelectJuridique] = useState('')
    const [conventions,setConventions]=useState([])
    const formJuridique = [
        {name: "EI"}, {name: "EIRL"}, {name: "EURL"}, {name: "SA"}, {name: "SARL"}, {name: "SAS"}, {name: "SASU"}]
    const jourOff = [
        {name: "Jour de l'an"},
        {name: "Lundi de pâques"},
        {name: "Fête du Travail"},
        {name: "Fête de la Victoire de 1945"},
        {name: "Jeudi de l'Ascension"},
        {name: "Lundi de pentecôte"},
        {name: "Fête nationale"},
        {name: "Assomption"},
        {name: "Toussaint"},
        {name: "Armistice de 1918"},
        {name: "Noël"},
        {name: "Abolition de l'esclavage Martinique"}]
    useEffect(()=>{
        ApiDataBase.getAllConventions(
            (data) => {
                setConventions(data)
            },
            (err) => {
                console.warn(err)
            }
        )
    },[])
    return (
        <div className="w-full px-2 tab:px-4 lg:px-8 py-8">
        <div className="flex flex-col gap-8 max-w-3xl">
            <div className="flex flex-col gap-6">
                <h2 className="text-xl font-medium text-gray-900">Informations légales</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Raison sociale
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.reason_social || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Siret
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.siret || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Effectif
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.staff || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Code APE
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.code_ape || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Capital social
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.capital ? companyData?.capital + ' €' : ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            Forme juridique
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.status || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            N° convention collective
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.conv_collective || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    <div className="flex flex-col gap-1">
                        <label className="text-xs font-medium text-gray-500 uppercase tracking-wide">
                            N° accord d'entreprise
                        </label>
                        <input 
                            type="text"
                            disabled
                            value={companyData?.accord_company || ''}
                            className="w-full h-10 pl-3 pr-8 text-sm bg-gray-100 border border-gray-200 rounded-lg text-gray-900"
                        />
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalInformationContent;
